"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyValueStore = exports.keyValueStoreGenerator = void 0;
function keyValueStoreGenerator() {
    return new KeyValueStore();
}
exports.keyValueStoreGenerator = keyValueStoreGenerator;
/**
 * Due to the fact that vqlweb/scriptsharp (host app) is not a React module,
 * we don't get any of the niceties that react provides for us, e.g.: don't render if props don't change.
 * This caused the rendering of @type {DataQualityWarningsInWebAuthoring} to flicker as the GraphQL query was made
 * because the component was re-rendered and mounted on every refresh in the host app.
 *
 * So we needed a way to store the content coming from the graph to both avoid incessant Graph API requests,
 * as well as the flickering that comes from those queries.
 * By storing the previous response somewhere we can pass that content along to the loading renderer for our component which hides the flicker.
 *
 * We had initially used SessionStorage, which disappears on tab closure and is supposed to be scoped to
 * protocol, domain, and port triple - but is not safe against XSS.
 * Since both SessionStorage and LocalStorage are not safe against XSS, so here we have a class that mimics the API of
 * SessionStorage and we can rely on the host app to hold onto a store for us.
 *
 * The host app doesn't need to know about the functions within this class though since it just
 * maintains a handle on the store and passes it into @type {DataQualityWarningsInWebAuthoringProps}
 */
var KeyValueStore = /** @class */ (function () {
    function KeyValueStore() {
        this.state = {};
    }
    KeyValueStore.prototype.setItem = function (key, value) {
        this.state[key] = value;
    };
    KeyValueStore.prototype.getItem = function (key) {
        var _a;
        return (_a = this.state[key]) !== null && _a !== void 0 ? _a : null;
    };
    KeyValueStore.prototype.tryGetAndParse = function (key) {
        try {
            var json = this.getItem(key);
            return !json ? null : JSON.parse(json);
        }
        catch (_a) {
            return null;
        }
    };
    KeyValueStore.prototype.removeItem = function (key) {
        this.state[key] = undefined;
    };
    KeyValueStore.prototype.clear = function () {
        this.state = {};
    };
    return KeyValueStore;
}());
exports.KeyValueStore = KeyValueStore;
//# sourceMappingURL=keyValueStoreGenerator.js.map